import './scss/index.scss';
import { dcFactory } from 'dc';
import TextTruncationComponent from './js/text-truncation.component';
import TextTruncationDesktopComponent from './js/text-truncation-desktop.component';

dcFactory.register(TextTruncationComponent);
dcFactory.register(TextTruncationDesktopComponent);
